import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function checkActivationUrl(data) {
    const payload = jsona.serialize({
        stuff: data,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/rzs-register/check-activation-url/${data.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function sendSmsCode(data) {
    const payload = jsona.serialize({
        stuff: data,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/rzs-register/send-sms-code/${data.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function checkSmsCode(data) {
    const payload = jsona.serialize({
        stuff: data,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/rzs-register/check-sms-code/${data.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function activateUserSetPwd(data) {
    const payload = jsona.serialize({
        stuff: data,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/rzs-register/activate-user-set-pwd/${data.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

export default {
    checkActivationUrl,
    sendSmsCode,
    checkSmsCode,
    activateUserSetPwd
};